import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles<string, { gutter: keyof ITheme['spacing'] }>(
  ({ spacing }: ITheme) => ({
    root: {
      listStyleType: 'none',
    },
    item: {
      marginBottom: (props) => spacing[props.gutter],

      '&:last-child': {
        marginBottom: 0,
      },
    },
  }),
  {
    name: 'list',
  },
);

export default useStyles;
